import { formatNumber } from '@/helpers/number';
import { useAppSelector } from '@/redux/hooks';

export default function usePointsFormatter(defaultPointName = 'point(s)') {
  const pointName = useAppSelector((state) => state.auth.companyAccount?.point_name) || defaultPointName;

  return (amount: number) => `${formatNumber(amount)} ${pointName}`;
}
